import { render, staticRenderFns } from "./detailStroke.vue?vue&type=template&id=b70fc56c&scoped=true"
import script from "./detailStroke.vue?vue&type=script&lang=js"
export * from "./detailStroke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70fc56c",
  null
  
)

export default component.exports